import React, { useState, useEffect } from "react";
import { db } from "../../firebase";
import { doc, getDoc, getDocs, collection } from "firebase/firestore";

export const DisplayPublishedBooks = ({
  booksPublished,
  booksPublishedCount,
}) => {
  const [books, setBooks] = useState([]);
  useEffect(() => {
    const fetchBooks = async () => {
      try {
        const fetchedBooks = await Promise.all(
          booksPublished.map(async (book) => {
            const isbn = book.isbn;
            try {
              const bookRef = doc(db, "books", isbn);
              const docSnap = await getDoc(bookRef);

              if (docSnap.exists()) {
                return docSnap.data();
              } else {
                console.log("No such document for ISBN:", isbn);
                return null;
              }
            } catch (error) {
              console.error("Error fetching book data for ISBN:", isbn, error);
              return null;
            }
          })
        );

        setBooks(fetchedBooks.filter((book) => book !== null));
      } catch (error) {
        console.error("Error fetching books:", error);
      }
    };

    fetchBooks();
  }, [booksPublished]);

  return (
    <div className="border-2 border-gray-700 m-1 p-2 rounded-lg">
      <div className="text-center">Published Books: {booksPublishedCount}</div>
      <div className="grid grid-cols-3">
  {booksPublished &&
    books.map((book, index) => (
      <div key={index} className="mb-5">
        {book ? (
          <img
            className="w-[8rem] h-[11rem]"
            src={
              book.volumeInfo &&
              book.volumeInfo.imageLinks &&
              book.volumeInfo.imageLinks.smallThumbnail
            }
            alt=""
          />
        ) : (
          <>Error</>
        )}
      </div>
    ))}
</div>

    </div>
  );
};

export const DisplayPublishedBooksForBooksPage = ({ userAuth }) => {
  const [publishedBooks, setPublishedBooks] = useState(null);
  const [publishedBooksCount, setPublishedBooksCount] = useState(0);
  useEffect(() => {
    const fetchPublishedBooks = async () => {
      try {
        const userRef = collection(db, "users", userAuth.uid, "publishedBooks");
        const querySnapshot = await getDocs(userRef);

        const booksPublished = [];
        querySnapshot.forEach((doc) => {
          booksPublished.push(doc.data());
        });
        setPublishedBooksCount(booksPublished ? booksPublished.length : 0);

        setPublishedBooks(booksPublished);
        console.log(booksPublished);
      } catch (error) {
        console.error("Error fetching published books:", error);
      }
    };

    fetchPublishedBooks();
  }, []);

  return (
    <>
      <h1>Published Books:</h1>
      <DisplayPublishedBooks  booksPublished ={publishedBooks}
        booksPublishedCount ={publishedBooksCount}/>
      
    </>
  );
};
